"use client";
import { Chip as DigDirChip } from "@digdir/designsystemet-react";
import cn from "clsx";
import * as React from "react";
const ChipCheckbox = React.forwardRef(({ className, hero, "data-color": dataColor, "data-size": dataSize, ...props }, ref) => {
    return (React.createElement(DigDirChip.Checkbox, { ref: ref, className: cn("in-chip__checkbox", hero && "in-chip-hero", className), "data-size": hero ? "lg" : dataSize, "data-color": hero ? "primary" : dataColor, ...props }));
});
ChipCheckbox.displayName = "ChipCheckbox";
export { ChipCheckbox };
//# sourceMappingURL=chipCheckbox.js.map